var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { renderFilter } from './render';
import { deriveConfig, deriveUrl } from '../parsing/deriveConfig';
import { parse, parseSiteMetadata } from '../parsing/parse';
import { FilterConfigurationSpec, } from '../parsing/UiTypesSpec';
import { loadFilterFromUrl } from './loaderv2';
import { resolveFilterSource } from './filterSource';
export var restoreFilter = function (imported) { return __awaiter(void 0, void 0, void 0, function () {
    var parsed, metadata, source, revision, _a, _b, base, config;
    var _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                parsed = parseSiteMetadata(imported.rs2f);
                if ((_c = parsed.errors) === null || _c === void 0 ? void 0 : _c.length)
                    throw new Error('Invalid filter restoration metadata');
                metadata = parsed.metadata;
                source = (_d = metadata === null || metadata === void 0 ? void 0 : metadata.source) !== null && _d !== void 0 ? _d : deriveUrl(imported);
                if (!source)
                    throw new Error('Could not determine original filter source');
                if (!(metadata === null || metadata === void 0 ? void 0 : metadata.revisionUrl)) return [3 /*break*/, 1];
                _a = { revisionUrl: metadata.revisionUrl, commit: metadata.commit };
                return [3 /*break*/, 5];
            case 1:
                if (!(metadata === null || metadata === void 0 ? void 0 : metadata.commit)) return [3 /*break*/, 3];
                return [4 /*yield*/, resolveFilterSource(source, metadata.commit)];
            case 2:
                _b = _g.sent();
                return [3 /*break*/, 4];
            case 3:
                _b = undefined;
                _g.label = 4;
            case 4:
                _a = _b;
                _g.label = 5;
            case 5:
                revision = _a;
                return [4 /*yield*/, loadFilterFromUrl(source, revision)];
            case 6:
                base = _g.sent();
                if ((metadata === null || metadata === void 0 ? void 0 : metadata.sourceHash) && base.rs2fHash !== metadata.sourceHash) {
                    throw new Error('The original filter content has changed. Exact restoration is unavailable; use Debug to re-associate it with a source manually.');
                }
                config = (metadata === null || metadata === void 0 ? void 0 : metadata.config)
                    ? FilterConfigurationSpec.parse(metadata.config)
                    : deriveConfig(base, imported);
                return [2 /*return*/, {
                        filter: __assign(__assign({}, base), { name: (_e = metadata === null || metadata === void 0 ? void 0 : metadata.name) !== null && _e !== void 0 ? _e : imported.name, description: (_f = metadata === null || metadata === void 0 ? void 0 : metadata.description) !== null && _f !== void 0 ? _f : imported.description }),
                        config: config,
                    }];
        }
    });
}); };
// A manual repair keeps this filter's identity and explicit settings. Derive
// baked-in customizations from its stored source before applying those settings.
export var reassociateFilter = function (existing, config, source, commit, revisionUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var revision, _a, base, configured, derived, enabledModules;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!revisionUrl) return [3 /*break*/, 1];
                _a = { revisionUrl: revisionUrl, commit: commit };
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, resolveFilterSource(source, commit)];
            case 2:
                _a = _c.sent();
                _c.label = 3;
            case 3:
                revision = _a;
                return [4 /*yield*/, loadFilterFromUrl(source, revision)];
            case 4:
                base = _c.sent();
                configured = parse(renderFilter(existing, __assign(__assign({}, config), { enabledModules: Object.fromEntries(existing.modules.map(function (module) { return [module.id, true]; })), inputConfigs: (_b = config === null || config === void 0 ? void 0 : config.inputConfigs) !== null && _b !== void 0 ? _b : {}, selectedThemeId: undefined, prefixRs2f: undefined, suffixRs2f: undefined })));
                if (!configured.filter)
                    throw new Error('Could not read the current filter settings');
                derived = deriveConfig(base, configured.filter);
                enabledModules = Object.fromEntries(base.modules
                    .filter(function (module) {
                    return !existing.modules.some(function (old) { return old.id === module.id; });
                })
                    .map(function (module) { return [module.id, false]; }));
                return [2 /*return*/, {
                        filter: __assign(__assign({}, base), { id: existing.id, name: existing.name, description: existing.description, active: existing.active, importedOn: existing.importedOn, updatedOn: new Date().toISOString() }),
                        config: __assign(__assign(__assign({}, derived), config), { enabledModules: __assign(__assign({}, enabledModules), config === null || config === void 0 ? void 0 : config.enabledModules), inputConfigs: __assign(__assign({}, config === null || config === void 0 ? void 0 : config.inputConfigs), derived.inputConfigs) }),
                    }];
        }
    });
}); };
